/**
 * Supported ISO 639 language codes for order management.
 */
export enum SupportedLanguages {
    DE = 'de', // German
    EN = 'en', // English
    NL = 'nl', // Dutch (Netherlands)
    TR = 'tr' // Turkish
}
